
import { Vue } from "vue-class-component";

export default class BookingCargo extends Vue {}
